import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { query, where, getDocs, collection } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
//page links  

import './footer.css';
import { GrUserWorker } from "react-icons/gr";
import { MdOutlineWorkOutline } from "react-icons/md";
import { BsPersonWorkspace } from "react-icons/bs";
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import { BsInstagram } from 'react-icons/bs';
import { BsFacebook } from 'react-icons/bs';
import { BsYoutube } from 'react-icons/bs';
import { BsLinkedin } from 'react-icons/bs';
import { BsX } from 'react-icons/bs';
export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Jobtasks, setJobtasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [rowCounts, setRowCounts] = useState({
    users: 0,
    postdata: 0,
    companys: 0,
    total: 0
  });

  //Jobtasks 
  useEffect(() => {
    const fetchJobtasks = async () => {
      try {
        // Fetch job posts
        const postQuery = query(
          collection(db, "postdata"),
          where("status", "==", true)
        );
        const postSnapshot = await getDocs(postQuery);
        const postCount = postSnapshot.size;

        // Fetch users
        const userQuery = query(
          collection(db, "users"),
          where("status", "==", true)
        );
        const userSnapshot = await getDocs(userQuery);
        const userCount = userSnapshot.size;

        const editor = userSnapshot.docs[0]
          ? { id: userSnapshot.docs[0].id, ...userSnapshot.docs[0].data() }
          : null;

        // Fetch companies
        const companyQuery = query(
          collection(db, "companys"),
          where("status", "==", true)
        );
        const companySnapshot = await getDocs(companyQuery);
        const companyCount = companySnapshot.size;

        const company = companySnapshot.docs[0]
          ? { id: companySnapshot.docs[0].id, ...companySnapshot.docs[0].data() }
          : null;

        // Combine data
        const JobtasksList = postSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          editor,
          company,
        }));

        // Update states
        setJobtasks(JobtasksList);
        setRowCounts({
          users: userCount,
          postdata: postCount,
          companys: companyCount,
          total: userCount + postCount + companyCount
        });

      } catch (error) {
        console.error("Error fetching job tasks:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // fetchJobtasks();
  }, []);


  return (
    <div className="footer-body">

      <div className="container_size">
        <div className='table-body'>
          <table className="footer-table">
            <tr>
              <td>
                <div className="logo-name"><b>Editer</b>Task.com</div>
              </td>
            </tr>
            {Cookies?.get("State") && (
              <tr>
                <td>
                  <div className="country-name">
                    {Cookies.get("State") + " / " + Cookies.get("Country")}
                  </div>
                </td>
              </tr>
            )}

            <tr>
              <td>
                <a className="tab-link" onClick={() => navigate('/help')}>Help & Support</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link">Phone +919530621728</a>
              </td>
            </tr>
            <tr>
              <td>
                <div className="social-icons">
                  <BsInstagram title='Follow on Instagram' onClick={() => window.open('https://www.instagram.com/editortask', '_blank')} />

                  {/* <BsFacebook onClick={() => window.open('https://www.facebook.com/editortask', '_blank')} /> */}
                  <BsYoutube title='Subscribe on YouTube' onClick={() => window.open('https://www.youtube.com/@editortask?sub_confirmation=1', '_blank')} />
                  {/* <BsLinkedin />
      <BsX /> */}
                </div>
              </td>
            </tr>
          </table>
          <table className="footer-table">
            <tr>
              <td>
                <div className="tab-title">Editortask</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='/dashboard' title='Categories'>Dashboard</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='/categories' title='Categories'>Categories</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" href='/creative-portfolios' title='Creative portfolios'>Creative portfolios</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='/hire-editors' title='Hire Editors'>Hire Editors</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='/typing-master' title='Typing Master' >Typing Master</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Post Job' href='/post-job'>Post Job</a>
              </td>
            </tr>


          </table>
          <table className="footer-table">
            <tr>
              <td>
                <div className="tab-title" >About</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='About' href='/about'>About us</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='How it Works' href='/how-it-works'>How it Works</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Security' href='/security'>Security</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Sitemap' href='/sitemap'>Sitemap</a>
              </td>
            </tr>

          </table>
          <table className="footer-table">
            <tr>
              <td>
                <div className="tab-title">Terms</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Privacy Policy' href='/privacy-policy'>Privacy Policy</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Terms and Conditions' href='/terms-and-conditions'>Terms and Conditions</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Copyright Policy' href='/copyright-policy'>Copyright Policy</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Code of Conduct' href='/code-of-conduct'>Code of Conduct</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Fees and Charges' href='/fees-and-charges'>Fees and Charges</a>
              </td>
            </tr>

          </table>
          <table className="footer-table">
            <tr>
              <td>
                <div className="tab-title">Business</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Partners' href='/partners'>Partners</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Skills Showcase' href='/skills'>Skills Showcase</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Locale Services' href='/locale-services'>Locale Services</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Company profile' href='/create-company-profile'>Company profile</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Business & Agency' href='/agency'>Business & Agency</a>
              </td>
            </tr>
          </table>
          <table className="footer-table">
            <tr>
              <td>
                <div className="tab-title">Apply on the Go</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='App dwonload' href='/app-dwonload'>Receive instant job updates directly on our app.</a>
              </td>
            </tr>
            <tr>
              <td>
                <img alt='Editortask Android app' title='Editortask Android app' src={GooglePlayIcon} className="app-img" />

              </td>
            </tr>

            <tr>
              <td>
                <img alt="Editortask iOS app" title='Editortask iOS app' src={Appstore} className="app-img" />
              </td>
            </tr>


          </table>
        </div>
      </div>

    </div>
  );
}
